import React, { Fragment } from 'react';
import { connect } from 'dva';
import { Card, Alert } from 'antd';
import styles from './AlertInfoCard.less';

@connect(() => ({}))
export default class AlertInfoCard extends React.Component {
  render() {
    const { userList } = this.props;

    if (!userList || userList.length === 0) {
      return null;
    }

    const totalStudent = userList.filter(user => user.groupType === 'STUDENT_GROUP');
    const totalStudentClass = [...new Set(totalStudent.map(user => user.curDepartName))];
    const totalTeacher = userList.filter(user => user.groupType === 'SCHOOL_WORKER_GROUP');

    const component = (
      <Fragment>
        <span>
          共选择<span className="alert-number">{userList.length}</span>人，
        </span>
        <span>
          其中已选择<span className="alert-number">{totalStudentClass.length}</span>个班级，
        </span>
        <span>
          学生<span className="alert-number">{totalStudent.length}</span>人；
        </span>
        <span>
          选择教师<span className="alert-number">{totalTeacher.length}</span>人
        </span>
      </Fragment>
    );

    return (
      <Card bordered={false} className={styles.root}>
        <Alert type="info" message={component} />
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/ChargeItem/PublishChargeItemSteps/Step3-Notification/AddressList/AlertInfoCard.js